module.exports = __webpack_public_path__ + "img/3ds.3f0ee484.svg";